<div class="nvme-now-dialog-plugin" hive-root>
    <div class="nvme-now-dialog-plugin__title-section">
        <h6 class="nvme-now-dialog-plugin__title">
            Recommendation Details for
            <b>{{ renderInfo().targetName }}</b>
        </h6>
    </div>
    <div class="nvme-now-dialog-plugin__body">
        <div class="nvme-now-dialog-plugin__heading">
            Upgrade from SAS to <span class="text-green bold">NVMe</span>
        </div>
        <table class="nvme-now-dialog-plugin__table">
            <thead>
                <tr>
                    <th colspan="2">Appliance Details</th>
                </tr>
            </thead>
            <tbody>
                @for (row of renderInfo().detailRows; track row.label) {
                    <tr>
                        <td class="nvme-now-dialog-plugin__row-label">{{ row.label }}</td>
                        <td class="nvme-now-dialog-plugin__row-value">
                            @for (value of row.values; track $index) {
                                <div>{{ value }}</div>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
        <div class="nvme-now-dialog-plugin__explain">
            Contact your Pure Storage account team to plan the upgrade path from SAS to NVMe.
        </div>
    </div>
    <footer class="nvme-now-dialog-plugin__footer">
        @if (renderInfo().allowDismiss) {
            <hive-button
                label="Dismiss Recommendation"
                emphasis="secondary"
                [disabled]="!renderInfo().allowDismiss() || renderInfo().actionInProgress()"
                hiveTooltip
                [hiveTooltipDescription]="renderInfo().allowDismiss() ? '' : 'Operation not permitted'"
                (click)="handleActionEvent(RecommendationActionEvent.DISMISS)"
            ></hive-button>
        }
        <hive-button
            label="Cancel"
            emphasis="secondary"
            [disabled]="renderInfo().actionInProgress()"
            (click)="handleActionEvent(RecommendationActionEvent.CANCEL)"
        ></hive-button>
        <hive-button
            label="Contact Account Team"
            emphasis="primary"
            [isLoading]="renderInfo().actionInProgress()"
            [disabled]="!renderInfo().allowContactAccountTeam() || renderInfo().actionInProgress()"
            hiveTooltip
            [hiveTooltipDescription]="renderInfo().allowContactAccountTeam() ? '' : 'Operation not permitted'"
            (click)="handleActionEvent(RecommendationActionEvent.CONTACT_ACCOUNT_TEAM)"
        ></hive-button>
    </footer>
</div>
